import React from 'react';
import './WhoCanApply.css';

function WhoCanApply() {
    return (
        <div className="who__can__apply">
            Для кого курс
        </div>
    )
}

export default WhoCanApply
